import React, { useState } from 'react'
import LegalPage from '../comps/legalPage'

const SUPPORT_EMAIL = 'support@pinweelo.com'

const ContactUs = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [sent, setSent] = useState(false)

  const canSend = name.trim() && email.trim() && message.trim()

  const onSubmit = (event) => {
    event.preventDefault()
    if (!canSend) return
    const subject = encodeURIComponent(`Pinweelo contact from ${name.trim()}`)
    const body = encodeURIComponent(`${message.trim()}\n\n${name.trim()}\n${email.trim()}`)
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`
    setSent(true)
  }

  return (
    <LegalPage
      title="Contact Pinweelo"
      heading="Contact us"
      description="Contact Pinweelo for account help, privacy questions, and general support."
    >
      <div className="legalContact legalRise">
        <img
          alt="Person writing a message"
          src="https://images.pexels.com/photos/12211252/pexels-photo-12211252.jpeg?auto=compress&cs=tinysrgb&w=1400"
        />
        <form className="legalForm" onSubmit={onSubmit}>
          <h2>Contact us</h2>
          <p>
            Questions about your account, a post, or Pinweelo itself? Send a message and we will get back to you.
          </p>
          <label>
            Name
            <input
              type="text"
              name="name"
              autoComplete="name"
              placeholder="Your name"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="you@email.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>
          <label>
            Message
            <textarea
              name="message"
              placeholder="How can we help?"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
          </label>
          <button type="submit" disabled={!canSend}>Send message</button>
          {sent ? <p className="legalOk">Your email app should open with the message ready to send.</p> : null}
          <p className="legalNote">
            You can also email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
          </p>
        </form>
      </div>

      <div className="legalGallery legalRise">
        <img alt="Studio lights" src="https://images.pexels.com/photos/3062541/pexels-photo-3062541.jpeg?auto=compress&cs=tinysrgb&w=900" />
        <img alt="Desk with a laptop" src="https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=900" />
        <img alt="Headphones and a phone" src="https://images.pexels.com/photos/3756766/pexels-photo-3756766.jpeg?auto=compress&cs=tinysrgb&w=900" />
      </div>
    </LegalPage>
  )
}

export default ContactUs
